import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { UiModalComponent } from '@components';
import { TranslateService } from '@ngx-translate/core';
import { UserGroupField } from '@pages/users/modals/user-group-import';
import { Subject } from 'rxjs';
var SCROLL_BUFFER = 300;
var CheckPermissionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CheckPermissionsModalComponent, _super);
    function CheckPermissionsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollBottom = new Subject();
        _this._translate = _this._injector.get(TranslateService);
        _this.formatRoleSources = function (sources) {
            return sources.map(function (source) { return source.isInherited
                ? source.username
                : _this._translate.instant('check_perms_modal_explicit'); }).join(', ');
        };
        return _this;
    }
    CheckPermissionsModalComponent.prototype.ngOnInit = function () {
        var _a;
        this.form = this._injector.get(FormBuilder).group((_a = {},
            _a[UserGroupField.UserName] = [[]],
            _a[UserGroupField.Domain] = [[]],
            _a));
        this.username = this.context.data && this.context.data.userName;
    };
    CheckPermissionsModalComponent.prototype.onScroll = function (event) {
        var elem = event.target;
        if ((elem.offsetHeight + elem.scrollTop + SCROLL_BUFFER) >= elem.scrollHeight) {
            this.scrollBottom.next();
        }
    };
    return CheckPermissionsModalComponent;
}(UiModalComponent));
export { CheckPermissionsModalComponent };
